import { compose } from 'redux'
import * as R from 'ramda'

import {
  withValidationSagas as validationSagas,
  withValidationError
} from 'containers/Form/Validation/index'
import { isHexId } from './predicates'

const withValidation = withValidationError(isHexId)
const withValidationSagas = validationSagas(isHexId)

export {
  withValidation,
  withValidationSagas
}
export default R.curry((path, id, selector, Component) => R.compose(
  withValidation(id),
  withValidationSagas(path, id, selector)
)(Component))
